<template>
  <span>
    <div>{{ value.name }}</div>
    <b-badge variant="info" class="pt-1">{{ value.status.name }}</b-badge>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
